import { Route } from '../../route.model';
import Billing from '@/views/Portal/Billing.vue';

const portalBilling = new Route('/portal/billing', 'portal-billing', Billing, {
  requiresAuth: true,
  isResponsive: true,
  zendesk: {
    disabled: true
  }
});

export { portalBilling };
export default portalBilling;
